import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useEffect, useRef } from "react";
import { VALUE_CODE } from "./RefundPreference";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  InputText,
  Heading,
} from "@ogt/ui";

export default function RefundValueCode() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 80;

  useEffect(() => {
    if (formData.refundpreference === VALUE_CODE) {
      setFormData((prev) => ({
        ...prev,
        clearingnumber: "",
        accountnumber: "",
      }));
    }
  }, [formData.compensation, setFormData]);

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/personuppgifter");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          valuecodeemail: Yup.string()
            .required("Vänligen fyll i din mejladress")
            .email("Vänligen ange en korrekt mejladress"),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading progress={progress} headingRef={h2Ref} focusable id="">
                  Värdekod
                </Heading>

                <p>
                  Du får värdekoden till din mejl. Värdekoden kan du sedan
                  använda för att köpa en ny biljett.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="valuecodeemail"
                  label={
                    <>
                      Mejladress för värdekod <span>(Obligatoriskt)</span>
                    </>
                  }
                  autocomplete={"email"}
                  type="email"
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
